import { render, staticRenderFns } from "./Sdg02.vue?vue&type=template&id=14bb80b8&scoped=true&"
import script from "./Sdg02.vue?vue&type=script&lang=js&"
export * from "./Sdg02.vue?vue&type=script&lang=js&"
import style0 from "./Sdg02.vue?vue&type=style&index=0&id=14bb80b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14bb80b8",
  null
  
)

export default component.exports